import { render } from "./MovieModal.vue?vue&type=template&id=18baadd2&scoped=true&ts=true"
import script from "./MovieModal.vue?vue&type=script&lang=ts"
export * from "./MovieModal.vue?vue&type=script&lang=ts"

import "./MovieModal.vue?vue&type=style&index=0&id=18baadd2&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18baadd2"]])

export default __exports__